module.exports = __webpack_public_path__ + "static/img/proximanova-regularit-webfont.0e9619a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximanova-regularit-webfont.svg
// module id = 33FP
// module chunks = 1